import { createContext } from 'react'

export const LineItemContext = createContext()
export const QuantityContext = createContext()

export const CartContext = createContext()
